export default function decrementSize(size) {
  return size === "lg" ? "md" : size === "md" ? "sm" : "xs";
}
